const enMessages = require('lang/message/en.json')

export const getSystemMessageById = (id, systemMessages = {}) => {
  return systemMessages?.[id] || enMessages?.[id]?.message || id
}
